import { Component } from "@angular/core";
import { ActionButtonKind, AuthService } from "shared-lib";

@Component({
    selector: "app-forbidden",
    templateUrl: "./forbidden.component.html",
    styleUrls: ["./forbidden.component.less"],
    standalone: false
})
export class ForbiddenComponent {

    ActionButtonKind = ActionButtonKind;

    constructor(
        private authService: AuthService,
    ) {}

    logOut() {

        this.authService.logout();
    }
}
